"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _memberManagement = require("@/api/member/memberManagement");
var _index = require("@/utils/index");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CouponManagement',
  props: {
    memberData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      // 搜索表单数据
      searchForm: {
        couponType: '',
        category: '',
        userId: null // 用户ID，用于筛选该会员的发券记录
      },
      // 表格数据
      tableData: [],
      // 加载状态
      loading: false,
      // 分页相关
      currentPage: 1,
      pageSize: 10,
      total: 0
    };
  },
  methods: {
    // 获取发券列表数据
    fetchCouponList: function () {
      var _fetchCouponList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.loading = true;
              _context.prev = 1;
              if (this.searchForm.userId) {
                _context.next = 2;
                break;
              }
              this.$message.warning('缺少用户ID，无法获取发券列表');
              this.loading = false;
              return _context.abrupt("return");
            case 2:
              params = _objectSpread({
                page: this.currentPage,
                // 当前页码
                limit: this.pageSize,
                // 每页条数
                userId: this.searchForm.userId
              }, this.searchForm); // 过滤空值参数（但保留userId）
              Object.keys(params).forEach(function (key) {
                if (key !== 'id' && (params[key] === '' || params[key] === null || params[key] === undefined)) {
                  delete params[key];
                }
              });
              _context.next = 3;
              return (0, _memberManagement.xyUserCouponBatchPage)(params);
            case 3:
              response = _context.sent;
              if (response.code === 200) {
                this.tableData = response.records || [];
                this.total = response.total || 0;
              } else {
                this.$message.error(response.message || '获取发券列表失败');
              }
              _context.next = 5;
              break;
            case 4:
              _context.prev = 4;
              _t = _context["catch"](1);
              this.$message.error('获取发券列表失败');
            case 5:
              _context.prev = 5;
              this.loading = false;
              return _context.finish(5);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 4, 5, 6]]);
      }));
      function fetchCouponList() {
        return _fetchCouponList.apply(this, arguments);
      }
      return fetchCouponList;
    }(),
    // 搜索功能
    handleSearch: function handleSearch() {
      this.currentPage = 1;
      this.fetchCouponList();
    },
    // 优惠券管理
    handleCouponManagement: function handleCouponManagement() {
      this.$message.info('跳转到优惠券管理页面');
      // TODO: 实现跳转到优惠券管理页面的逻辑
      // 可以使用 this.$router.push() 进行页面跳转
    },
    // 分页大小改变
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchCouponList();
    },
    // 当前页改变
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchCouponList();
    },
    // 获取券类型文本
    getCouponTypeText: function getCouponTypeText(type) {
      var typeMap = {
        1: '代金券',
        2: '折扣券',
        3: '商品券',
        4: '赠品券'
      };
      return typeMap[type] || '未知类型';
    },
    // 格式化时间
    formatTime: function formatTime(time) {
      if (!time) return '';
      return (0, _index.parseTime)(time, '{y}-{m}-{d} {h}:{i}:{s}');
    },
    // 格式化日期为年月日格式
    formatDate: function formatDate(date) {
      if (!date) return '';
      // 如果是时间戳，转换为Date对象
      var dateObj = typeof date === 'number' ? new Date(date) : new Date(date);
      if (isNaN(dateObj.getTime())) return '';
      var year = dateObj.getFullYear();
      var month = String(dateObj.getMonth() + 1).padStart(2, '0');
      var day = String(dateObj.getDate()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day);
    }
  },
  watch: {
    // 监听memberData变化，确保userId始终正确
    'memberData.id': {
      handler: function handler(newUserId) {
        if (newUserId) {
          this.searchForm.userId = newUserId;
          // 如果userId发生变化，重新获取数据
          this.currentPage = 1;
          this.fetchCouponList();
        }
      },
      immediate: true
    }
  },
  mounted: function mounted() {
    // 设置用户ID用于筛选
    if (this.memberData && this.memberData.userId) {
      this.searchForm.userId = this.memberData.userId;
      console.log('已设置userId为:', this.searchForm.userId);
    } else {
      console.warn('未接收到有效的memberData或userId');
    }
    // 初始化时获取发券数据
    this.fetchCouponList();
  }
};